import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { IonApp, IonRouterOutlet, IonBadge } from '@ionic/react';

import { IonReactRouter } from '@ionic/react-router';

import { IonIcon, IonLabel, IonTabBar, IonTabButton, IonTabs, IonContent, IonSpinner } from '@ionic/react';

import {
  homeOutline as home,
  personCircleOutline as person,
  cartOutline as cart,
  calendarOutline as calendar,
  keyOutline as login,
  pricetagsOutline as promotions,
  documentTextOutline as prescription,
  chatbubblesOutline as chat,
  medkitOutline as rental,
} from 'ionicons/icons';

// import AuthResource from './resources/Auth';
// import CartResource from './resources/Cart';

import PublicRoute from './components/PublicRoute';
import PrivateRoute from './components/PrivateRoute';

import HomePage from './pages/HomePage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/Checkout/CheckoutPage';

import GestPayPage from './pages/Payment/GestPayPage';
import NexiPage from './pages/Payment/NexiPage';
import PayPalPage from './pages/Payment/PayPalPage';

import PaymentEndPage from './pages/Payment/PaymentEndPage';
import ReservationPaymentPage from './pages/Payment/ReservationPaymentPage';
import ReservationPaymentEndPage from './pages/Payment/ReservationPaymentEndPage';
import SearchPage from './pages/SearchPage';
import CategoryPage from './pages/CategoryPage';
import ProductPhoto from './pages/ProductPhoto';
import Galenica from './pages/Galenica';
import ShopServices from './pages/ShopServices';
import ShopServicesInfo from './pages/ShopServiceInfo';
import ShopServiceGroup from './pages/ShopServiceGroup';
import PrescriptionSelect from './pages/Prescription/PrescriptionSelect';
import PrescriptionPage from './pages/Prescription/PrescriptionPage';
import PrescriptionRequestPage from './pages/PrescriptionRequest/PrescriptionRequestPage';
import PrescriptionRequestsList from './pages/PrescriptionRequest/PrescriptionRequestsList';
import PrescriptionRequestDetail from './pages/PrescriptionRequest/PrescriptionRequestDetail';
import ProductPage from './pages/ProductPage';
import AddressesPage from './pages/AddressesPage';
import AddressPage from './pages/AddressPage';
import ReferrerPage from './pages/ReferrerPage';
import FiscalcodesPage from './pages/FiscalcodesPage';
import FiscalcodePage from './pages/FiscalcodePage';

import OrdersPage from './pages/OrdersPage';
import OrderPage from './pages/OrderPage';
import ProfilePage from './pages/ProfilePage';
import SettingsPage from './pages/SettingsPage';
import FAQPage from './pages/FAQPage';
import PromotionsPage from './pages/PromotionsPage';
import ShiftsPage from './pages/ShiftsPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import ResetPassword from './pages/ResetPassword';
import ReservationManagePage from './pages/ReservationManagePage';
import VaccineResponsePage from './pages/VaccineResponsePage';
import PrivacyCheckPage from './pages/PrivacyCheckPage';
import PrivacyPage from './pages/PrivacyPage';
import TosPage from './pages/TosPage';
import ThankyouPage from './pages/ThankyouPage';
import OrderConfirmedPage from './pages/OrderConfirmedPage';
import ChatPage from './pages/ChatPage';

import ReservationsPage from './pages/ReservationsPage';
import ReservationPage from './pages/ReservationPage';
import EventReservation from './pages/EventReservation';

import ShopEvent from './pages/ShopEvent';
import EventDetails from './pages/EventDetails';
import ServiceDetails from './pages/ServiceDetails';
import ServiceList from './pages/ServiceList';
import RentalDeviceList from './pages/RentalDeviceList';
import RentalDeviceDetails from './pages/RentalDeviceDetails';
import VaccinesPage from './pages/VaccinesPage';
import MyVaccinesPage from './pages/MyVaccinesPage';

import FidelityCardPage from './pages/FidelityCard/FidelityCardPage';
// import FidelityCardsPage from './pages/FidelityCard/FidelityCardsPage';
// import FidelityCardPage from './pages/FidelityCard/ManyFidelityCardPage';

import OfflinePage from './pages/OfflinePage';
import WhatsappWidget from './components/Whatsapp/WhatsappWidget';

//import { logoWhatsapp } from 'ionicons/icons';
import OptionService from './services/option';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

import SystemResource from './resources/System';
import AuthResource from './resources/Auth';
import CartResource from './resources/Cart';

import TrackingService from './services/tracking';
import PromotionPostService from './services/promotionPosts';
import ConfigService from './services/config';

import { createBrowserHistory } from 'history';

import useViewport from './hooks/useViewport';
import DesktopLayout from './layouts/DesktopLayout';
import DesktopHomePage from './pages/DesktopHomePage';

import './layouts/styles/desktop.js';

// EventEmitter.on restituisce l'emitter: qui si restituisce la funzione che rimuove il listener
const subscribe = (emitter, eventName, listener) => {
  emitter.on(eventName, listener);
  return () => emitter.off(eventName, listener);
};

const history = createBrowserHistory();

// Wrapper per usare hook in class component
function withViewport(WrappedComponent) {
  return function WithViewportWrapper(props) {
    const viewport = useViewport();
    return <WrappedComponent {...props} viewport={viewport} />;
  };
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      productsNumber: 0,
      reservationsNumber: 0,
      isOnline: true,
      toast: [],
      chatDisabled: true,
      promotions: 0,
      hasPromotionPosts: false,
      showcart: true,
      showreservation: true,
      checkprivacy: false,
      options: null,
      orders: null,
      fpsConfigs: null,
      isLoading: true,
    };
  }

  async componentDidMount() {
    this._isMounted = true;

    TrackingService.view();
    this.historyUnlisten = history.listen(() => {
      TrackingService.view();
    });

    try {
      const response = await OptionService.allClean();
      const options = response.data.data;

      if (this._isMounted) {
        this.setState({ options });
      }
    } catch (error) {
      console.error('Errore nel fetch degli ordini:', error);
    }

    const fpsConfigs = await ConfigService.getFpsConfigs();
    if (this._isMounted) {
      this.setState({ fpsConfigs, isLoading: false });
    }

    // Mostra il bottone Promozioni solo se c'è almeno una promozione valida
    try {
      const promotionPosts = await PromotionPostService.getAll();
      if (this._isMounted) {
        this.setState({ hasPromotionPosts: promotionPosts.data?.data?.length > 0 });
      }
    } catch (error) {
      console.error('Errore nel fetch delle promozioni:', error);
    }

    const updateCart = async () => {
      if (!this._isMounted) return;

      if (!!!(await AuthResource.isLogged)) {
        return;
      }

      let cart = await CartResource.current();

      if (!!cart.data && this._isMounted) {
        this.setState({
          productsNumber:
            cart.data.products.reduce((sum, el) => (sum += el.quantity), 0) +
            (this.state.options?.prescriptions !== '0' ? cart.data.prescriptions.length : 0) +
            cart.data.product_requests.length,
        });
      }
    };

    try {
      const [result] = await Promise.allSettled([OptionService.get('promotions')]);

      if (result.status === 'fulfilled') {
        // The promise was fulfilled, check the response structure
        const promotionsValue = result.value?.data?.value;

        // Check if promotionsValue is defined and is a valid JSON string
        if (promotionsValue && typeof promotionsValue === 'string' && promotionsValue !== 'undefined') {
          try {
            const parsedPromotions = JSON.parse(promotionsValue);
            if (this._isMounted) {
              await this.setState({ promotions: parsedPromotions.length });
            }
          } catch (parseError) {
            console.error('Error parsing promotions JSON:', parseError);
            if (this._isMounted) {
              await this.setState({ promotions: 0 });
            }
          }
        } else {
          // If promotionsValue is not a string, is undefined, or is the string "undefined"
          if (this._isMounted) {
            await this.setState({ promotions: 0 });
          }
        }
      } else {
        // The promise was rejected
        console.error('Promise rejected for promotions:', result.reason);
        if (this._isMounted) {
          await this.setState({ promotions: 0 });
        }
      }
    } catch (error) {
      console.error('Error in promotions fetch:', error);
      if (this._isMounted) {
        await this.setState({ promotions: 0 });
      }
    }

    this.authLoginUnsubscribe = subscribe(AuthResource, 'auth:login', updateCart);
    this.authLogoutUnsubscribe = subscribe(AuthResource, 'auth:logout', async () => {
      if (this._isMounted) {
        await this.setState({ productsNumber: undefined });
      }
    });

    this.authUnauthorizedUnsubscribe = subscribe(AuthResource, 'auth:unauthorized', async () => {
      if (this._isMounted) {
        await this.setState({ productsNumber: undefined });
      }
    });

    this.cartUpdateUnsubscribe = subscribe(CartResource, 'cart:update', updateCart);
    try {
      updateCart();
    } catch (error) {
      console.error(error);
    }

    SystemResource.activeCheck();
    SystemResource.privacyCheck();
    this.systemVersionUnsubscribe = subscribe(SystemResource, 'system:version', () => window.location.reload());
    this.systemOnlineUnsubscribe = subscribe(SystemResource, 'system:online', () => {
      if (this._isMounted) {
        this.setState({ isOnline: true });
      }
    });
    this.systemOfflineUnsubscribe = subscribe(SystemResource, 'system:offline', () => {
      if (this._isMounted) {
        this.setState({ isOnline: false });
      }
    });

    this.privacyCheckOnUnsubscribe = subscribe(SystemResource, 'privacycheck:on', () => {
      if (this._isMounted) {
        this.setState({ checkprivacy: true });
      }
    });
    this.privacyCheckOffUnsubscribe = subscribe(SystemResource, 'privacycheck:off', () => {
      if (this._isMounted) {
        this.setState({ checkprivacy: false });
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;

    if (this.historyUnlisten) {
      this.historyUnlisten();
    }

    if (this.authLoginUnsubscribe) {
      this.authLoginUnsubscribe();
    }
    if (this.authLogoutUnsubscribe) {
      this.authLogoutUnsubscribe();
    }
    if (this.authUnauthorizedUnsubscribe) {
      this.authUnauthorizedUnsubscribe();
    }
    if (this.cartUpdateUnsubscribe) {
      this.cartUpdateUnsubscribe();
    }
    if (this.systemVersionUnsubscribe) {
      this.systemVersionUnsubscribe();
    }
    if (this.systemOnlineUnsubscribe) {
      this.systemOnlineUnsubscribe();
    }
    if (this.systemOfflineUnsubscribe) {
      this.systemOfflineUnsubscribe();
    }
    if (this.privacyCheckOnUnsubscribe) {
      this.privacyCheckOnUnsubscribe();
    }
    if (this.privacyCheckOffUnsubscribe) {
      this.privacyCheckOffUnsubscribe();
    }
  }

  render() {
    const { checkprivacy, isOnline, showcart, showreservation, isLoading, fpsConfigs, options, hasPromotionPosts, promotions: promotionsNumber } = this.state;
    const { viewport } = this.props;

    // Le ricette inviate dall'app sono attive per default: solo il valore '0' le disabilita
    const prescriptionsEnabled = options?.prescriptions !== '0';

    const checkCondition = (condition) => {
      if (!fpsConfigs) return false; // Se non ci sono config, blocca

      if (typeof condition === 'function') {
        return condition(fpsConfigs);
      }
      return condition;
    };

    const routeConfigs = {
      public: {
        other: [
          { path: '/auth/login', component: LoginPage, condition: true, exact: true },
          { path: '/auth/reset/:token', component: ResetPassword, condition: true, exact: true },
          // Path corto usato dal link di recupero password inviato via SMS/email
          { path: '/r/:token', component: ResetPassword, condition: true, exact: true },
          // Link di gestione prenotazione inviato nei promemoria, senza login
          { path: '/p/:token', component: ReservationManagePage, condition: true, exact: true },
          // Link di risposta alla proposta vaccino, senza login
          { path: '/v/:token', component: VaccineResponsePage, condition: true, exact: true },
          {
            path: '/app/home',
            component: this.props.viewport?.width >= 1024 ? DesktopHomePage : HomePage,
            condition: true,
            exact: true,
          },
          { path: '/app/shift', component: ShiftsPage, condition: true, exact: true },
          { path: '/app/faq', component: FAQPage, condition: true, exact: true },
          { path: '/app/privacycheck', component: PrivacyCheckPage, condition: true, exact: true },
          { path: '/app/privacy', component: PrivacyPage, condition: true, exact: true },
          { path: '/app/tos', component: TosPage, condition: true, exact: true },
          { path: '/app/offline', component: OfflinePage, condition: true, exact: true },
          { path: '/app/promotions', component: PromotionsPage, condition: true, exact: true },
        ],
        products: [
          {
            path: '/app/search',
            component: SearchPage,
            condition: (configs) => configs?.products > 0,
            exact: true,
          },
          {
            path: '/app/category',
            component: CategoryPage,
            condition: (configs) => configs?.products > 0,
            exact: true,
          },
          {
            path: '/app/category/:category1',
            component: CategoryPage,
            condition: (configs) => configs?.products > 0,
            exact: true,
          },
          {
            path: '/app/category/:category1/:category2',
            component: CategoryPage,
            condition: (configs) => configs?.products > 0,
            exact: true,
          },
          {
            path: '/app/category/:category1/:category2/:category3',
            component: CategoryPage,
            condition: (configs) => configs?.products > 0,
            exact: true,
          },
          {
            path: '/app/category/:category1/:category2/:category3/:category4',
            component: CategoryPage,
            condition: (configs) => configs?.products > 0,
            exact: true,
          },
          {
            path: '/app/product/:code',
            component: ProductPage,
            condition: (configs) => configs?.products > 0,
            exact: true,
          },
        ],
        services: [
          {
            path: '/app/services',
            component: ShopServices,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
          {
            path: '/app/services/:id',
            component: ShopServices,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
          {
            path: '/app/serviceinfo/:id',
            component: ShopServicesInfo,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
          {
            path: '/app/service_group/:id',
            component: ShopServiceGroup,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
          {
            path: '/app/service/category/:id',
            component: ServiceList,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
          {
            path: '/app/service/category/:id/:service_id',
            component: ServiceDetails,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
          {
            path: '/app/service/category/:id/shop/:shopService_id',
            component: ServiceDetails,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
          { path: '/app/events', component: ShopEvent, condition: (configs) => configs?.services > 0, exact: true },
          {
            path: '/app/events/:id/:data',
            component: EventDetails,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
          {
            path: '/app/eventReservation/:id/:data/:serviceId',
            component: EventReservation,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
          {
            path: '/app/reservations/:id',
            component: ReservationPage,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
        ],
        rentals: [
          {
            path: '/app/rentals',
            component: RentalDeviceList,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
          {
            path: '/app/rentals/:id',
            component: RentalDeviceDetails,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
        ],
      },
      private: {
        other: [
          { path: '/app/user', component: UserPage, condition: true, exact: true },
          { path: '/app/chat', component: ChatPage, condition: options?.chat !== '0', exact: true },
          { path: '/app/referrer', component: ReferrerPage, condition: true, exact: true },
          { path: '/app/addresses', component: AddressesPage, condition: true, exact: true },
          { path: '/app/address', component: AddressPage, condition: true, exact: true },
          { path: '/app/address/:id', component: AddressPage, condition: true, exact: true },
          { path: '/app/fiscalcodes', component: FiscalcodesPage, condition: true, exact: true },
          { path: '/app/fiscalcode', component: FiscalcodePage, condition: true, exact: true },
          { path: '/app/fiscalcode/:id', component: FiscalcodePage, condition: true, exact: true },
          { path: '/app/profile', component: ProfilePage, condition: true, exact: true },
          { path: '/app/settings', component: SettingsPage, condition: true, exact: true },
          { path: '/app/checkout', component: CheckoutPage, condition: true, exact: true },
          { path: '/app/payment-end', component: PaymentEndPage, condition: true, exact: true },
          { path: '/app/reservation-payment-end', component: ReservationPaymentEndPage, condition: true, exact: true },
          { path: '/app/reservations/:id/payment', component: ReservationPaymentPage, condition: true, exact: true },
          { path: '/app/payment/nexi/:id', component: NexiPage, condition: true, exact: true },
          { path: '/app/payment/gestpay/:id', component: GestPayPage, condition: true, exact: true },
          { path: '/app/payment/paypal/:id', component: PayPalPage, condition: true, exact: true },
          { path: '/app/thankyou/:id', component: ThankyouPage, condition: true, exact: true },
          { path: '/app/fidelityCard', component: FidelityCardPage, condition: true },
          // { path: '/app/fidelityCards', component: FidelityCardsPage, condition: true },
          // { path: '/app/fidelityCard/:id', component: ManyFidelityCardPage, condition: true },
          {
            path: '/app/prescription-request',
            component: PrescriptionRequestPage,
            condition: (configs) => configs?.prescription_request > 0 && prescriptionsEnabled,
            exact: true,
          },
          {
            path: '/app/prescription-request/new/:type',
            component: PrescriptionRequestPage,
            condition: (configs) => configs?.prescription_request > 0 && prescriptionsEnabled,
            exact: true,
          },
          {
            path: '/app/prescription-request/list',
            component: PrescriptionRequestsList,
            condition: (configs) => configs?.prescription_request > 0 && prescriptionsEnabled,
            exact: true,
          },
          {
            path: '/app/prescription-request/:id(\\d+)',
            component: PrescriptionRequestDetail,
            condition: (configs) => configs?.prescription_request > 0 && prescriptionsEnabled,
            exact: true,
          },
        ],
        products: [
          { path: '/app/orders', component: OrdersPage, condition: (configs) => configs?.products > 0, exact: true },
          { path: '/app/orders/:id', component: OrderPage, condition: (configs) => configs?.products > 0, exact: true },
          {
            path: '/app/order-confirmed/:id',
            component: OrderConfirmedPage,
            condition: (configs) => configs?.products > 0,
            exact: true,
          },
          { path: '/app/cart', component: CartPage, condition: (configs) => configs?.products > 0, exact: true },
          {
            path: '/app/prescription',
            component: PrescriptionSelect,
            condition: (configs) => configs?.products > 0 && prescriptionsEnabled,
            exact: true,
          },
          {
            path: '/app/prescription/fse',
            component: PrescriptionPage,
            condition: (configs) => configs?.products > 0 && prescriptionsEnabled,
            exact: true,
          },
          {
            path: '/app/prescription/nre',
            component: PrescriptionPage,
            condition: (configs) => configs?.products > 0 && prescriptionsEnabled,
            exact: true,
          },
          {
            path: '/app/prescription/file',
            component: PrescriptionPage,
            condition: (configs) => configs?.products > 0 && prescriptionsEnabled,
            exact: true,
          },
          {
            path: '/app/prescription/vetnre',
            component: PrescriptionPage,
            condition: (configs) => configs?.products > 0 && prescriptionsEnabled,
            exact: true,
          },
          {
            path: '/app/prescription/vetfile',
            component: PrescriptionPage,
            condition: (configs) => configs?.products > 0 && prescriptionsEnabled,
            exact: true,
          },
          {
            path: '/app/prescription/:id',
            component: PrescriptionPage,
            condition: (configs) => configs?.products > 0 && prescriptionsEnabled,
          },
          {
            path: '/app/productphoto',
            component: ProductPhoto,
            condition: (configs) => configs?.products > 0,
            exact: true,
          },
          {
            path: '/app/productphoto/:id',
            component: ProductPhoto,
            condition: (configs) => configs?.products > 0,
            exact: true,
          },
          { path: '/app/galenica', component: Galenica, condition: (configs) => configs?.products > 0, exact: true },
          {
            path: '/app/galenica/:id',
            component: Galenica,
            condition: (configs) => configs?.products > 0,
            exact: true,
          },
        ],
        services: [
          {
            path: '/app/reservations',
            component: ReservationsPage,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
          {
            path: '/app/reservations/:path/:eventId/:serviceId',
            component: ReservationPage,
            condition: (configs) => configs?.services > 0,
            exact: true,
          },
        ],
        vaccines: [
          {
            path: '/app/vaccini',
            component: VaccinesPage,
            condition: (configs) => configs?.vaccines > 0,
            exact: true,
          },
          {
            path: '/app/vaccini/miei',
            component: MyVaccinesPage,
            condition: (configs) => configs?.vaccines > 0,
            exact: true,
          },
        ],
      },
    };

    if (!isOnline) {
      return (
        <IonApp>
          <OfflinePage />
        </IonApp>
      );
    }

    if (isLoading || !fpsConfigs) {
      return (
        <IonApp>
          <IonContent className="ion-padding">
            <IonSpinner />
          </IonContent>
        </IonApp>
      );
    }

    if (checkprivacy) {
      return (
        <IonApp>
          <IonReactRouter history={history}>
            <IonRouterOutlet>
              <PublicRoute
                path="/app/privacy"
                component={PrivacyPage}
                fpsConfigs={fpsConfigs}
                condition={true}
                exact={true}
              />
              <PublicRoute path="/app/tos" component={TosPage} fpsConfigs={fpsConfigs} condition={true} exact={true} />
              <PublicRoute
                path="/p/:token"
                component={ReservationManagePage}
                fpsConfigs={fpsConfigs}
                condition={true}
                exact={true}
              />
              <PublicRoute
                path="/v/:token"
                component={VaccineResponsePage}
                fpsConfigs={fpsConfigs}
                condition={true}
                exact={true}
              />
              <PublicRoute component={PrivacyCheckPage} fpsConfigs={fpsConfigs} condition={true} />
            </IonRouterOutlet>
          </IonReactRouter>
        </IonApp>
      );
    }

    // Desktop layout per viewport larga
    if (viewport.width >= 1024) {
      return (
        <IonApp>
          <IonReactRouter history={history}>
            <DesktopLayout fpsConfigs={fpsConfigs} options={options} hasPromotionPosts={hasPromotionPosts} promotionsNumber={promotionsNumber}>
              <IonRouterOutlet>
                {routeConfigs.public.other.map((route, index) => (
                  <PublicRoute
                    key={route.path || `privacy-route-${index}`}
                    path={route.path}
                    component={route.component}
                    fpsConfigs={fpsConfigs}
                    options={options}
                    condition={checkCondition(route.condition)}
                    exact={route.exact}
                  />
                ))}

                {routeConfigs.public.products.map((route, index) => (
                  <PublicRoute
                    key={route.path || `privacy-route-${index}`}
                    path={route.path}
                    component={route.component}
                    fpsConfigs={fpsConfigs}
                    condition={checkCondition(route.condition)}
                    exact={route.exact}
                  />
                ))}

                {routeConfigs.public.services.map((route, index) => (
                  <PublicRoute
                    key={route.path || `privacy-route-${index}`}
                    path={route.path}
                    component={route.component}
                    fpsConfigs={fpsConfigs}
                    condition={checkCondition(route.condition)}
                    exact={route.exact}
                  />
                ))}

                {routeConfigs.public.rentals.map((route, index) => (
                  <PublicRoute
                    key={route.path || `rental-route-${index}`}
                    path={route.path}
                    component={route.component}
                    fpsConfigs={fpsConfigs}
                    condition={checkCondition(route.condition)}
                    exact={route.exact}
                  />
                ))}

                {routeConfigs.private.other.map((route, index) => (
                  <PrivateRoute
                    key={route.path || `privacy-route-${index}`}
                    path={route.path}
                    component={route.component}
                    fpsConfigs={fpsConfigs}
                    options={options}
                    condition={checkCondition(route.condition)}
                    exact={route.exact}
                  />
                ))}

                {routeConfigs.private.products.map((route, index) => (
                  <PrivateRoute
                    key={route.path || `privacy-route-${index}`}
                    path={route.path}
                    component={route.component}
                    fpsConfigs={fpsConfigs}
                    options={options}
                    condition={checkCondition(route.condition)}
                    exact={route.exact}
                  />
                ))}

                {routeConfigs.private.services.map((route, index) => (
                  <PrivateRoute
                    key={route.path || `privacy-route-${index}`}
                    path={route.path}
                    component={route.component}
                    fpsConfigs={fpsConfigs}
                    condition={checkCondition(route.condition)}
                    exact={route.exact}
                  />
                ))}

                {routeConfigs.private.vaccines.map((route, index) => (
                  <PrivateRoute
                    key={route.path || `vaccine-route-${index}`}
                    path={route.path}
                    component={route.component}
                    fpsConfigs={fpsConfigs}
                    condition={checkCondition(route.condition)}
                    exact={route.exact}
                  />
                ))}

                <Redirect from="/app" to="/app/home" exact={true} />
                <Redirect from="/" to="/app/home" exact={true} />
              </IonRouterOutlet>
            </DesktopLayout>
          </IonReactRouter>

          <WhatsappWidget options={options} desktop />
        </IonApp>
      );
    }

    // Mobile layout (con tabs)
    return (
      <IonApp>
        <IonReactRouter history={history}>
          <IonTabs>
            <IonRouterOutlet>
              {routeConfigs.public.other.map((route, index) => (
                <PublicRoute
                  key={route.path || `privacy-route-${index}`}
                  path={route.path}
                  component={route.component}
                  fpsConfigs={fpsConfigs}
                  condition={checkCondition(route.condition)}
                  exact={route.exact}
                />
              ))}

              {routeConfigs.public.products.map((route, index) => (
                <PublicRoute
                  key={route.path || `privacy-route-${index}`}
                  path={route.path}
                  component={route.component}
                  fpsConfigs={fpsConfigs}
                  condition={checkCondition(route.condition)}
                  exact={route.exact}
                />
              ))}

              {routeConfigs.public.services.map((route, index) => (
                <PublicRoute
                  key={route.path || `privacy-route-${index}`}
                  path={route.path}
                  component={route.component}
                  fpsConfigs={fpsConfigs}
                  condition={checkCondition(route.condition)}
                  exact={route.exact}
                />
              ))}

              {routeConfigs.public.rentals.map((route, index) => (
                <PublicRoute
                  key={route.path || `rental-route-${index}`}
                  path={route.path}
                  component={route.component}
                  fpsConfigs={fpsConfigs}
                  condition={checkCondition(route.condition)}
                  exact={route.exact}
                />
              ))}

              {routeConfigs.private.other.map((route, index) => (
                <PrivateRoute
                  key={route.path || `privacy-route-${index}`}
                  path={route.path}
                  component={route.component}
                  fpsConfigs={fpsConfigs}
                  options={options}
                  condition={checkCondition(route.condition)}
                  exact={route.exact}
                />
              ))}

              {routeConfigs.private.products.map((route, index) => (
                <PrivateRoute
                  key={route.path || `privacy-route-${index}`}
                  path={route.path}
                  component={route.component}
                  fpsConfigs={fpsConfigs}
                  options={options}
                  condition={checkCondition(route.condition)}
                  exact={route.exact}
                />
              ))}

              {routeConfigs.private.services.map((route, index) => (
                <PrivateRoute
                  key={route.path || `privacy-route-${index}`}
                  path={route.path}
                  component={route.component}
                  fpsConfigs={fpsConfigs}
                  condition={checkCondition(route.condition)}
                  exact={route.exact}
                />
              ))}

              {routeConfigs.private.vaccines.map((route, index) => (
                <PrivateRoute
                  key={route.path || `vaccine-route-${index}`}
                  path={route.path}
                  component={route.component}
                  fpsConfigs={fpsConfigs}
                  condition={checkCondition(route.condition)}
                  exact={route.exact}
                />
              ))}

              <Redirect from="/app" to="/app/home" exact={true} />
              <Redirect from="/" to="/app/home" exact={true} />
            </IonRouterOutlet>

            <IonTabBar slot="bottom">
              <IonTabButton tab="home" href="/app/home">
                <IonIcon icon={home} />
                <IonLabel>Home</IonLabel>
              </IonTabButton>

              {fpsConfigs?.products > 0 && options?.buy_products_in_app === '1' && showcart > 0 && (
                <IonTabButton tab="cart" href="/app/cart">
                  <IonIcon icon={cart} />
                  <IonLabel>Carrello</IonLabel>
                  {!!this.state.productsNumber ? <IonBadge>{this.state.productsNumber}</IonBadge> : null}
                </IonTabButton>
              )}

              {/* {fpsConfigs?.services > 0 && showreservation > 0 && (
                <IonTabButton tab="reservations" href="/app/reservations">
                  <IonIcon icon={calendar} />
                  <IonLabel>Prenotazioni</IonLabel>
                  {!!this.state.reservationsNumber ? <IonBadge>{this.state.reservationsNumber}</IonBadge> : null}
                </IonTabButton>
              )} */}

              {/* {fpsConfigs?.rentals > 0 && showreservation > 0 && (
                <IonTabButton tab="rentals" href="/app/rentals">
                  <IonIcon icon={rental} />
                  <IonLabel>Noleggi</IonLabel>
                </IonTabButton>
              )} */}

              {(promotionsNumber > 0 || hasPromotionPosts || options?.volantino) && showcart > 0 && (
                <IonTabButton tab="promotions" href="/app/promotions">
                  <IonIcon icon={promotions} />
                  <IonLabel>Promozioni</IonLabel>
                </IonTabButton>
              )}

              {fpsConfigs?.prescription_request > 0 && prescriptionsEnabled && (
                <IonTabButton tab="prescription-request" href="/app/prescription-request">
                  <IonIcon icon={prescription} />
                  <IonLabel>Ricette</IonLabel>
                </IonTabButton>
              )}

              {options?.chat !== '0' && (
                <IonTabButton tab="chat" href="/app/chat">
                  <IonIcon icon={chat} />
                  <IonLabel>Chat</IonLabel>
                </IonTabButton>
              )}

              {!!AuthResource.token ? (
                <IonTabButton tab="user" href="/app/user">
                  <IonIcon icon={person} />
                  <IonLabel>Account</IonLabel>
                </IonTabButton>
              ) : (
                <IonTabButton tab="login" href="/auth/login">
                  <IonIcon icon={login} />
                  <IonLabel>Accedi </IonLabel>
                </IonTabButton>
              )}
            </IonTabBar>
          </IonTabs>
        </IonReactRouter>

        <WhatsappWidget options={options} />
      </IonApp>
    );
  }
}

export default withViewport(App);
